var _rect, _polygon, _path, _rect2, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiservLogoOrangeFf6600(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.68,
    height: 36,
    viewBox: "0 0 71.68 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.1,
    y: 31.11,
    width: 4.58,
    height: 4.58,
    fill: "#f60"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "57.82 10.73 60.55 31.18 63.27 10.73 67.51 10.73 63.54 35.68 57.5 35.68 53.57 10.73 57.82 10.73",
    fill: "#f60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35,10.73H0v3.32H2.35v21.64H6.49V14.04h2.91v-3.32h-2.91V5.66c0-.74,.15-1.31,.51-1.69,.36-.39,.91-.57,1.65-.57h.75V0h-1.5c-1.84,0-3.61,.39-4.45,1.19-.84,.8-1.09,2.04-1.09,3.81v5.72Z",
    fill: "#f60"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.69,
    y: 10.73,
    width: 4.15,
    height: 24.95,
    fill: "#f60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34,24.62h8.65v-7.69c-.01-4.6-2.22-6.49-6.41-6.49s-6.4,1.88-6.4,6.52v12.64c.01,4.22,2.57,6.4,6.4,6.4s6.4-1.8,6.42-6.4v-2h-4.01s0,1.78,0,2.37c0,1.69-.63,2.86-2.33,2.86s-2.32-1.18-2.32-2.86v-5.35Zm0-8.52c0-1.41,.37-2.87,2.31-2.87s2.33,1.44,2.33,2.86v5.16h-4.64v-5.16Z",
    fill: "#f60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.17,21.5c-3.13-2.75-3.39-3.13-3.39-5.16,0-1.74,.15-2.79,1.71-2.79s1.76,1.04,1.76,2.81v2.3h4v-3.76c-.01-2.95-2.28-4.45-5.85-4.45s-5.8,1.17-5.82,5.89c0,.8,0,.8,0,.49,0,1.48,.01,3.83,3.68,6.98l1.05,.9c2.7,2.28,3,2.55,2.99,5.26,0,1.67-.1,2.94-1.86,2.94s-1.86-1.28-1.86-2.06v-3.19h-4.2v3.29c0,4.05,2.64,5.06,6.06,5.06s6.06-1.01,6.06-6.23v-.43c0-3.64-.67-4.62-4.33-7.84Z",
    fill: "#f60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2,13.3v-2.57h-3.78v24.95h4.08V18.29c0-1.34,.44-2.23,1.2-2.75,.72-.5,1.61-.67,2.74-.68v-4.42c-2.16,.04-3.1,.47-4.2,2.76l-.04,.09Z",
    fill: "#f60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiservLogoOrangeFf6600);
export default __webpack_public_path__ + "static/media/fiserv-logo-orange-ff6600.b5364649a54c3ed670e95f9d9f108fb2.svg";
export { ForwardRef as ReactComponent };